import React, { useEffect, useState } from 'react';

import { useCart } from '../../../hooks/useCart';

import { Order } from './Order';

import { AdaptiveModal } from '../AdaptiveModal';

export const OrderModal = () => {
  const { showOrderModal, setShowOrderModal, setCartOpen } = useCart();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCartOpen(false);
  }, [setCartOpen]);

  return (
    <AdaptiveModal
      open={showOrderModal}
      onOpen={setShowOrderModal}
      closeDisabled={loading}
      contentStyle={{
        width: '90%',
        maxWidth: '400px',
        overflow: 'visible'
      }}
    >
      <Order loading={loading} setLoading={setLoading} />
    </AdaptiveModal>
  );
};
